module.exports = "<div id=\"strength\"> <small jhiTranslate=\"global.messages.validate.newpassword.strength\">Password strength:</small> <ul id=\"strengthBar\"> <li class=\"point\"></li> <li class=\"point\"></li> <li class=\"point\"></li> <li class=\"point\"></li> <li class=\"point\"></li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/account/password/password-strength-bar.component.html
// module id = 299
// module chunks = 0